///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { uniqBy } from "lodash";

export const getCommonCarrierMatches = (carrierMatches, rowsSelected) => {
  if (rowsSelected.length > 1 && carrierMatches) {
    const uniqCarrierMatches = uniqBy(carrierMatches, c => c.carrierId);
    let commonCarrierMatches = [];
    uniqCarrierMatches.forEach(carrierMatch => {
      if (
        carrierMatches.filter(x => x.carrierId === carrierMatch.carrierId)
          ?.length === rowsSelected.length
      ) {
        commonCarrierMatches.push(carrierMatch);
      }
    });
    return commonCarrierMatches;
  }
  return carrierMatches;
};

export default getCommonCarrierMatches;
